/*
  中文
*/

export default {
  // 刊登编辑页面 edit
  publishEdit: {
    listings: '列表',
    Platform: '站台',
    Store: '商店',
    ProductTitle: '产品名称',
    Tags: '标签',
    Custom: '习惯',
    Collections: '收藏',
    Description: '描述',
    Variants: '变体',
    Images: '图片',
    listNow: '现在列出',
    CancelEditing: '取消编辑',
    tips1: '不超过40000个字符',
    tips2: '仅支持JPG、JPEG和PNG图像。',
    ShippingMethod: '发货方式',
    Product: '产品',
    SKU: 'SKU',
    size: '尺寸',
    color: '颜色',
    ProductCost: '产品成本',
    ShippingCost: '运费',
    CompareAtPrice: '比价',
    SuggestedPrice: '建议价格',
    Profi: '利润',
    Quantity: '数量',
    tips3: '包括航运公司',
    tips4: '最多支持250个图像',
    tips5: '最多支持40个图像',
    SuggestedPriceTips1: '销售价格=原价*（1+加价）+运费',
    CompareAtPriceTips1: '对比价格=产品成本*（1+利润率）+运输成本',
    SuggestedPriceTips2: '（如果您选择了“包括运费”）',
    SuggestedPriceTips3: '一次单击即可修改所有价格',
    NewPrice: '新价格',
    cancel: '取消',
    confirm: '提交',
    Percentage: '百分率',
    OneClickModification: '一键修改',
    ProductionEditor: '产品编辑器',
    SyncCollection: '匹配集合',
    selectContent: '选择内容',
    ShippingFrom: '起点',
    ShippingTo: '终点',
    EstimatedDeliveryTime: '预计交货时间',
    NoPictures: '没有照片',
    loadingText: '加载中...',
    repeat: '重复!',
    IncorrectLogisticsInformation: '发货方式不能为空',
    PictureCannotBeEmpty: '图片不能为空',
    SKUCannotBeEmpty: 'SKU不能为空',
    inputLength: '长度为255以下',
    richTextCheck: '富文本字数不可超过40000',
    CompareAtPriceCheck: '比较价格必须高于建议价格',
    CompareAtPriceCheckShoplazza: '价格比较必须高于',
    titleCheck: '标题不能为空',
    DescriptionCheck: '描述不能为空',
    ShelfStatusUp: '该产品将提前在商店出售',
    ShelfStatusDowm: '该产品之前已在该店上市。',
    ProfitMargin: '利润率',
    imageMaxLengthTips: '最多只能选择250张图片',
    imageMaxLengthTips2: '最多只能选择40张图片',
    tagLength: '最多设置10个标签',
    isFilterDuplicateSpuText: '同一产品将重复刊登',
    beenListed: '失败，项目已经列出。'
  },
  publishListings: {
    listings: '列表',
    Published: '已刊登',
    Hidden: '隐藏',
    ListingQueue: '正在列出队列',
    Deleted: '已删除',
    productSelected: '已选择产品',
    Product: '产品',
    ProductId: '产品Id',
    priceScope: '价格范围',
    CompareAtPrice: '按价格进行比较',
    Inventory: '库存',
    EditProduct: '编辑产品',
    More: '更多',
    Synchronous: '同步',
    Relist: '重新登录',
    PublishedIn: '发表于...',
    Delete: '删除',
    synType1Title: '在列表中...',
    synType5Title: '上架中...',
    synType4Title: '店铺下架中...',
    synType10Title: '同步中...',
    synType2Title: '产品更新中...',
    noProduct: '对不起，您尚未添加产品',
    ChooseProduct: '选择产品',
    ConnectANewStore: '连接新店',
    hiddenComfirmTitle: '你确定要从商店里把产品下架吗?',
    RelistComfirmTitle: '您确定要将产品重新登录到商店吗？',
    deleteComfirmTitle: '您确定要从您的商店中删除该产品吗？',
    synType3Title: '删除中...',
    searchBy: '搜索内容',
    SelectStore: '选择商店',
    store: '店铺',
    productName: '产品名称'
  },
  productList: {
    wishList: '愿望清单',
    productList: '产品清单',
    Delete: '删除',
    productSelected: '选择的产品',
    deleteTip1: '是否确实要删除选中的产品？',
    submit: '提交',
    cancel: '取消',
    Description: '描述',
    Inventory: '库存',
    Price: '价格',
    ProductType: '产品类型',
    Action: '行动',
    Detail: '详情',
    more: '更多',
    ListToStore: '要存储的列表',
    customized: '定制的',
    goodsInStock: '库存商品',
    tatusTips: '该产品不可用。',
    canFind: '抱歉，找不到~请重新搜索',
    ItemNo: '项目编号',
    contentPlaceholder: '请输入产品关键字',
    Listing: '表册',
    YourPrice: '您的价格',
    From: '发货地',
    ShipTo: '收货地',
    Cancel: '取消',
    ListNow: '现在列出',
    Platform: '平台',
    Store: '店铺',
    ShipMyOdersMostTo: '订单最远送到',
    ShippingMethod: '运送渠道',
    logisticsTips: '发货地、收货地、运送渠道只要选择了其中一项必须全部选择',
    batchPublishTips: '批量上传产品最多只能添加100个产品',
    storeTips: '一次只能上传到 1 个商店',
    priceTips: '您的价格=价格*输入系数（输入时间而不是费率。）',
    shipTips: '所选物流模式仅用作系统支持的物流',
    ShippingMethodTips: '可选（你可以在发货前调整）',
    inputPlaceholder: '搜索内容',
    haveShelves: '列表失败：包含不可用的项目。!',
    textareaPlaceholder: '用逗号或换行分隔多个搜索',
    repeatListTip: '勾选后您选择的产品如果产品已上架会再重新上架另外一条listing',
    repeatList: '重复列表',
    priceRatioGT20Tip: '您上传的产品将会以20倍的销售价上传产品',
    yourPrice: '您的价格'
  },
  batchTasks: {
    batchTasks: '批量处理任务',
    Status: '状态',
    contentPlaceholder: '搜索',
    Number: '编号',
    StoreInformation: '店铺信息',
    ItemNo: '项目编号',
    PublicationSituation: '发布情况',
    FailedToLoad: '加载失败',
    Success: '成功',
    uploading: '上传中',
    ListingFailed: 'Listing failed',
    CreationTime: '创建时间',
    Pending: '待处理',
    Processing: '处理中',
    Completed: '已完成',
    contentPlaceholder2: '搜索项目编号',
    Platform: '平台',
    Store: '店铺',
    Product: '产品',
    ReasonForFailure: '失败原因',
    data: '数据'
  }
}
